const Chapter02 = [
  {
    id: 0,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_001.jpg",
    alt: "AllSkies02_001",
  },
  {
    id: 1,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_002.jpg",
    alt: "AllSkies02_002",
  },
  {
    id: 2,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_003.jpg",
    alt: "AllSkies02_003",
  },
  {
    id: 3,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_004.jpg",
    alt: "AllSkies02_004",
  },
  {
    id: 4,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_005.jpg",
    alt: "AllSkies02_005",
  },
  {
    id: 5,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_006.jpg",
    alt: "AllSkies02_006",
  },
  {
    id: 6,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_007.jpg",
    alt: "AllSkies02_007",
  },
  {
    id: 7,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_008.jpg",
    alt: "AllSkies02_008",
  },
  {
    id: 8,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_009.jpg",
    alt: "AllSkies02_009",
  },
  {
    id: 9,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_010.jpg",
    alt: "AllSkies02_010",
  },
  {
    id: 10,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_011.jpg",
    alt: "AllSkies02_011",
  },
  {
    id: 11,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_012.jpg",
    alt: "AllSkies02_012",
  },
  {
    id: 12,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_013.jpg",
    alt: "AllSkies02_013",
  },
  {
    id: 13,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_014.jpg",
    alt: "AllSkies02_014",
  },
  {
    id: 14,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_015.jpg",
    alt: "AllSkies02_015",
  },
  {
    id: 15,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_016.jpg",
    alt: "AllSkies02_016",
  },
  {
    id: 16,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_017.jpg",
    alt: "AllSkies02_017",
  },
  {
    id: 17,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_018.jpg",
    alt: "AllSkies02_018",
  },
  {
    id: 18,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_019.jpg",
    alt: "AllSkies02_019",
  },
  {
    id: 19,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_020.jpg",
    alt: "AllSkies02_020",
  },
  {
    id: 20,
    image: "https://ik.imagekit.io/prismalotus/Chapter02/AllSkies02_021.jpg",
    alt: "AllSkies02_021",
  },
];

export default Chapter02;
